import type { AppIconName } from "@shared/ui/chakra/data-display/icon/icon.tsx";

import { Box, Flex } from "@chakra-ui/react";
import { type MessageDescriptor, useIntl } from "react-intl";

import { closeAllOpenOverlays } from "@app/navigation/close-all-open-overlays";
import { NavBarLink } from "@app/navigation/ui/nav-bar-link.tsx";

import { navigationMessages } from "./messages";

type NavigationItem = {
  activeIconName: AppIconName;
  iconName: AppIconName;
  label: MessageDescriptor;
  path: string;
};

const links: NavigationItem[] = [
  {
    activeIconName: "HomeFill",
    iconName: "Home",
    label: navigationMessages.homeLabel,
    path: "/wallet",
  },
  {
    activeIconName: "ClockLineFill",
    iconName: "ClockLine",
    label: navigationMessages.transactionsLabel,
    path: "/transactions",
  },
  {
    activeIconName: "ProfileFill",
    iconName: "Profile",
    label: navigationMessages.profileLabel,
    path: "/profile",
  },
];

export const NavBar = () => {
  const { formatMessage } = useIntl();
  return (
    <Flex gap={{ md: "16px" }} justifyContent="center">
      {links.map((link) => (
        <Box key={link.path} flex={1} minW={0} overflow="hidden">
          <NavBarLink
            activeIconName={link.activeIconName}
            iconName={link.iconName}
            label={formatMessage(link.label)}
            outline="none"
            to={link.path}
            onClick={closeAllOpenOverlays}
          />
        </Box>
      ))}
    </Flex>
  );
};
